import { AnalyticsActionSubject, AnalyticsAction } from '../../types';
import { type InviteeListId } from '../../analytics';
import { BaseInvitePeopleAnalytics } from '../../analytics/BaseInvitePeopleAnalytics';

export class InviteeListAnalytics extends BaseInvitePeopleAnalytics {
	inviteeListItemAdded(
		id: InviteeListId,
		attributes: {
			domains: string[];
		},
	): void {
		this.fireUI({
			actionSubject: AnalyticsActionSubject.INVITEE_LIST_ITEM,
			actionSubjectId: AnalyticsActionSubject.INVITEE_LIST_ITEM + id,
			action: AnalyticsAction.ADDED,
			attributes: { ...attributes },
		});
	}

	inviteeListFocused(id: InviteeListId): void {
		this.fireUI({
			actionSubject: AnalyticsActionSubject.INVITEE_LIST,
			actionSubjectId: AnalyticsActionSubject.INVITEE_LIST + id,
			action: AnalyticsAction.CLICKED,
		});
	}

	inviteeListPrefilled(numUsersPrefilled: number): void {
		const { source } = this.commonAttributes;
		this.fireUI({
			actionSubject: AnalyticsActionSubject.INVITEE_LIST,
			action: AnalyticsAction.PREFILLED,
			attributes: { numUsersPrefilled, source },
		});
	}

	teamOrUserPickerViewed(attributes: { teamIds: string[] }): void {
		this.fireScreen({
			name: AnalyticsActionSubject.TEAM_OR_USER_PICKER,
			attributes,
		});
	}

	slackChannelClicked(teamId: string): void {
		this.fireUI({
			actionSubject: AnalyticsActionSubject.BUTTON,
			actionSubjectId: AnalyticsActionSubject.INVITEE_LIST_ITEM_USER_PICKER,
			action: AnalyticsAction.CLICKED,
			attributes: {
				source: AnalyticsActionSubject.TEAM_OR_USER_PICKER,
				teamId,
			},
		});
	}

	slackUserSelected(): void {
		this.fireTrack({
			action: AnalyticsAction.SELECTED,
			actionSubject: AnalyticsActionSubject.SLACK_USER,
		});
	}

	userPickerTyped(attributes: {
		queryLength: number;
		results: { type: string | null; sources?: string[] }[];
	}): void {
		this.fireTrack({
			action: AnalyticsAction.TYPED,
			actionSubject: AnalyticsActionSubject.USER_PICKER,
			attributes: {
				context: 'invite-user-picker',
				pickerType: 'multi',
				numberOfResults: attributes.results.length,
				...attributes,
			},
		});
	}
	userPickerAutoOpened(attributes: { numberOfResults: number }): void {
		this.fireUI({
			action: AnalyticsAction.AUTO_OPENED,
			actionSubject: AnalyticsActionSubject.USER_PICKER,
			attributes: {
				context: 'invite-user-picker',
				pickerType: 'multi',
				...attributes,
			},
		});
	}
}
